import { render, staticRenderFns } from "./CardFasilitasGudang.vue?vue&type=template&id=1f63113c&"
import script from "./CardFasilitasGudang.vue?vue&type=script&lang=js&"
export * from "./CardFasilitasGudang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports